import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('kamig_auth');
    if (stored) {
      const { user } = JSON.parse(stored);
      setUser(user);
    }
    setLoading(false);
  }, []);

  const loginUser = (authData) => {
    localStorage.setItem('kamig_auth', JSON.stringify(authData));
    setUser(authData.user);
  };

  const logout = () => {
    localStorage.removeItem('kamig_auth');
    setUser(null);
  };

  const updateUser = (updatedUser) => {
    const stored = localStorage.getItem('kamig_auth');
    if (stored) {
      const authData = JSON.parse(stored);
      authData.user = updatedUser;
      localStorage.setItem('kamig_auth', JSON.stringify(authData));
    }
    setUser(updatedUser);
  };

  if (loading) return null;

  return (
    <AuthContext.Provider value={{ user, loginUser, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
